module.exports = __webpack_public_path__ + "8f815c939eefaefca75cd74a883210b7.png";